import { toast } from "react-toastify";
import axiosInstance from "../../../utils/axiosUtil";
import { getError } from "../../../utils/error";

export const getAll = async (
  dispatch,
  token,
  status,
  curPage,
  resultPerPage,
  query,
  currentDriver
) => {
  let url = `/api/admin/trip/?status=${status}&keyword=${query}&resultPerPage=${resultPerPage}&currentPage=${curPage}&currentDriver=${currentDriver}`;

  try {
    dispatch({ type: "FETCH_REQUEST" });
    const { data } = await axiosInstance.get(url, {
      headers: { Authorization: token },
    });
    console.log("all trips", data);
    dispatch({ type: "FETCH_SUCCESS", payload: data });
  } catch (error) {
    dispatch({ type: "FETCH_FAIL", payload: getError(error) });
  }
};

export const del = async (dispatch, token, id) => {
  if (window.confirm("Are you sure you want to delete this trip?") === true) {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      await axiosInstance.delete(`/api/admin/trip/${id}`, {
        headers: { Authorization: token },
      });
      toast.success("Trip Deleted Successfully");
      dispatch({ type: "DELETE_SUCCESS", payload: id });
    } catch (error) {
      dispatch({ type: "FETCH_FAIL", payload: getError(error) });
    }
  }
};

export const update = async (dispatch, token, id, userInfo) => {
  try {
    dispatch({ type: "UPDATE_REQUEST" });

    await axiosInstance.put(`/api/admin/user/${id}`, userInfo, {
      headers: { Authorization: token },
    });

    setTimeout(() => {
      dispatch({ type: "UPDATE_SUCCESS" });
    }, 2000);
  } catch (err) {
    dispatch({ type: "UPDATE_FAIL", payload: getError(err) });
  }
};

export const getDetails = async (dispatch, token, id) => {
  // console.log(token, id);
  try {
    dispatch({ type: "FETCH_DETAILS_REQUEST" });

    const { data } = await axiosInstance.get(`/api/admin/trip/${id}`, {
      headers: { Authorization: token },
    });

    console.log("trip", data);
    dispatch({ type: "FETCH_DETAILS_SUCCESS", payload: data });
  } catch (err) {
    dispatch({
      type: "FETCH_DETAILS_FAIL",
      payload: getError(err),
    });
  }
};
